webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

module.exports = [{"slug":"gezicht","title":"gezicht ダムの素顔を追った一年間の記録。","year":"2017年","description":"CSS3の縦書きスタイルを使用したWebサイト","text":"たてよこWebアワード出品作品。CSS3の縦書きを使用したWebサイト。","role":"構築・設計・コーディング・ライティング・写真撮影","urlTitle":"gezicht","url":"//dam.becolomochi.com/gezicht","tags":["個人活動","Webサイト制作"],"picture":[{"id":"1","path":"http://drive.google.com/uc?export=view&id=0BzPW0pNckTNURjFDdm5fM3FfNVk"},{"id":"2","path":"http://drive.google.com/uc?export=view&id=0BzPW0pNckTNUUEdQSWlxR2lMa28"},{"id":"3","path":"http://drive.google.com/uc?export=view&id=0BzPW0pNckTNUWnZRQldYSi02T2M"}]},{"slug":"ghpages","title":"べこ のプロフィール - GitHub pages","year":"2017年","description":"自身関連のURLをまとめたGitHub pages","text":"自身関連のURLをまとめたGitHub pages","role":"デザイン・コーディング・イラスト","urlTitle":"GitHub pages","url":"//develop.becolomochi.com","tags":["個人活動","Webサイト制作"],"picture":[{"id":"1","path":"http://drive.google.com/uc?export=view&id=0BzPW0pNckTNUc0J1aFNod2FPRUk"},{"id":"2","path":"http://drive.google.com/uc?export=view&id=0BzPW0pNckTNUWVRJQnBXUTF2RFU"}]}]

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Top__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_Works__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_Works___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layouts_Works__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorksTop__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorksTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_WorksTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorksDetail__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorksDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_WorksDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Contact__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageNotFound__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PageNotFound__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Top',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Top___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About___default.a
  }, {
    path: '/works',
    component: __WEBPACK_IMPORTED_MODULE_4__components_layouts_Works___default.a,
    children: [{
      path: '/',
      name: 'Works',
      component: __WEBPACK_IMPORTED_MODULE_5__components_WorksTop___default.a
    }, {
      path: ':slug',
      name: 'WorksDetail',
      component: __WEBPACK_IMPORTED_MODULE_6__components_WorksDetail___default.a
    }]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Contact___default.a
  }, {
    path: '*',
    name: 'Not Found',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PageNotFound___default.a,
    title: 'Not Found'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var description = this.$options.description;

    var meta = document.getElementsByTagName('meta');

    if (description) {
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() == 'description') {
          meta[i].content = description;
        }
      }
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var title = this.$options.title;

    if (title) {
      title = typeof title === 'function' ? title.call(this) : title;
      document.title = title + ' - becolomochi\'s portfolio';
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(39),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_parts_NavHeader__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_parts_NavHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_parts_NavHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_NavFooter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_NavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_parts_NavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_data_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_data_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    hnav: __WEBPACK_IMPORTED_MODULE_0__components_parts_NavHeader___default.a,
    fnav: __WEBPACK_IMPORTED_MODULE_1__components_parts_NavFooter___default.a
  },
  data: function data() {
    return {
      myData: __WEBPACK_IMPORTED_MODULE_2__static_data_json___default.a
    };
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  title: 'About',
  description: 'べこ（becolomochi）の経歴・仕事観・性格・好きなものについて書いたページです。'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  title: 'Contact',
  description: 'べこ（becolomochi）へのお問い合わせページ',
  methods: {
    sendMessage: function sendMessage() {
      var form = $('form');
      var message = $('#message');
      var submitBtn = $('#submit');

      if (!message.val()) {
        alert('メッセージを入力してください');
        return false;
      }
      $.ajax({
        url: 'https://script.google.com/macros/s/AKfycbwnF5oozNN5mgFhDtE252daSjJMPZULVLywV2bJmv82t3Y3U7PC/exec',
        dataType: 'jsonp',
        data: form.serialize(),
        beforeSend: function beforeSend() {
          return submitBtn.prop('disabled', true);
        },
        complete: function complete() {
          return submitBtn.prop('disabled', false), message.val(''), alert('送信完了しました');
        },
        error: function error(response) {
          alert('送信エラーです');
          return;
        }
      });
      event.preventDefault();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  title: 'Not Found',
  description: ''
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top',
  title: 'Top',
  description: 'べこ（becolomochi）のポートフォリオサイト',
  props: ['data']
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  mounted: function mounted() {
    document.title = this.filteredData.title + '- becolomochi\'s portfolio';

    var meta = document.getElementsByTagName('meta');
    for (var i = 0; i < meta.length; i++) {
      if (meta[i].name.toLowerCase() == 'description') {
        meta[i].content = 'becolomochiが作成した ' + this.filteredData.title + ' のページです';
      }
    }
  },

  computed: {
    filteredData: function filteredData() {
      var url = window.location.protocol + '//' + window.location.host + '/works/';
      var matchData = this.data.filter(function (item, index) {
        if (item.slug === window.location.href.replace(url, '')) return true;
      });
      return matchData[0];
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  title: 'Works',
  description: 'べこ（becolomochi）の作品一覧',
  props: ['data']
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_data_json__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      myData: __WEBPACK_IMPORTED_MODULE_0__static_data_json___default.a
    };
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_title__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_description__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_style_style_scss__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_style_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_style_style_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_2__util_title__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_3__util_description__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-22728284-8',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon1.f11a1b0.png";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon2.6b63f3e.jpg";

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADMCAMAAAABFxy6AAAACXBIWXMAABJ0AAASdAHeZh94AAAAY1BMVEVHcEz////////////////////////////////////////////////////////////////6m5v92tr6oaH/+fn7tLT+5ub+7Oz9zc3+8/P94OD7qKj8wcH909P7rq78x8f8uroKY9cdAAAAEHRSTlMA759gv9/PgEAQMCCvcFCPgz+v3wAABK9JREFUeNrtm+eCqjoUhUUpiqBJIPTi+z/lDcWRouMZCBC96/t39sAxi92SQHY7AAAAAAAAAAAA/BunY4NrjTi0f1J05MfjRQzS0XXdIH/AFDfsxY3bCzsfratuEimYunWwN/GCpWtENprjnldNgoNDFsN0TyvJuCyoovHLfg23HAyyAotLWUdGLWXJADuaZD00azEpFlkX47JM0zDJ6jgLOMXWyAZo0p1y2USH/KQ/kM0wZVZim2yIZn94fjyUHGRNrQyyMZKUOGRzpCxY3O11SMmTs6aAEGLOr8I6UQJn9kSRKMLcHm+oIkQ7fWpLlxtcujpCZtVgWyEdxJwhZK+SkDkNXlNKiDF9FULU4vIdkUWI/vFN5M7ERdZ5lcH5f7j2Kn16Env5wBLE5K3lGRlNFk/3XzayAhqROOkZbqNLbqO7+GjQOR0JCVn00ku21FxPWJDRW0Fp0B02Z8lAyNBCSiG/D6M063k6v3mUji77wZU6P6ENN3aP8ogF4slS7xH3I0sN70pvdTxC1E+ytLqH8yyUW7deCQmjiNKQ/KRA2Ap7/PzYUuPROmby8Mdp9P4wGhGUFm8yRnb1pWmceNx/KPOEMpLfOI/i55aIc16NtKxURm3F+NHhV64oGS3e1bBJSfJLyWyjK7v/bkzT+gE/wmloqUKfprwae+g1iZF1cqG8MZ9w720tPkoVEqQ0jTIqoiH178WnrOy+KDnJc0sc+KnwEatqWdi4gg8KVthP/KdYU4S82n9n1KOR74kHfbv/dEGH+Tm2hLSoa1mtMq3/n9Tvl2K2jJAXyR56RUKFQ1gVP94jjvodc2QRkZTfhZCiaKpY0b0gGhY1Wb39hRDuxQFNmwFR2jaIkgxbRjmSVmVA1LWLYCt7QvJl5o3X5w4RKSqSva4vSfNIfY8OpiNji3j8UR1xrNc0u/8MB6EmTcjzKYoIgJg3A/DbYbHaPSHrptHY4vmxSIN+YSqpF3e18ndK9vImjRFNvSrbRbAUbYynbRG6JUGQ+E8tonmwsqrAbOg53s0+6mVR7stO9tOLiS9NGUn8OGvjSwRYnfKsbhV11I8tkRhwko4bN+vN2MKi7k6yhbyov3HQzje86N5Wmsfs51k7Txpb/ODFcy76GZ6UnIfS94Suv0Vrwv6yJHq9ssn/dPm0/UaltrVmbaQot2ifuNZd/WOHt0x94XP+kshSbmdr+qap/SUOUcwlc14snL+gZKlWuPRZOhT47uH+nmfuG2pF8l2f/6ZdhU8fJs56latchpyv50/mtjI0dyeJTZUYB4lfA26mRNtLPpKxiRLzusDBktO6GW/o1nGpL7Hd1SS4x2VPXtjmsgIcoWClQz2WJnnsAsuyLusfsjpPyRR9X5922+QE1S9Srn/yiuMqNv5u/frnE1bm4bRTm7PrrDY/Wt4ve2356epK2NbLgmzYu89CJIy2xGpuE8bJ/5k6Kr9YvYW99qk6arcYcrafFMDV5rzmU6q7tK+zz7uPZ/8VDqkzhcw/VqAG1sQvqtTD0b9EyMn5EiG74w4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8L/nPyjJVc4AUwkKAAAAAElFTkSuQmCC"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADMCAMAAAABFxy6AAAACXBIWXMAABJ0AAASdAHeZh94AAAAY1BMVEVHcEz///////////////////////////////////////////////////////////////+X25nL7czl9uax5LP5/fme3Z/y+/Ls+Oy+6b+r4qzY8tnF68bS79Kk4Kbf9N+45rn1B91CAAAAEHRSTlMAYCBwnxDvQIC/3zCvz1CPDElFHQAAA7VJREFUeNrt2+l2qjAUBWAmmURJmGf7/k95w6CC7b0Xakgwa3+/auuybE9OEhA1DQAAAAAAAAAAAAAAAAAAAAAAAECus+OYLhN6d5Y7MZ2BcejjPzm6a3kXshYLGLJk5wNFYAmC9QG+sb3QdE6Si2CGnk+48C1TSnEM3fVswplt6UIrY5gB9wwPgagsJ/NCdmY5AophERF8fedqhESUXaM4PhHI322AuUSwYJ+2t4hw9g5FOV2IDKYK9RinYs45QkKUSHIlRIkkhk3USBIQqbitjQ6RjNf+3pMd5KJIQQhxVeiQAY/LFacD5OAyc+lHCMKjJAFRpCQ2UaMkxqZ/V6T/+mue/z5IKHTyvdHqJUmdxc8HWfbGuYm4Xu8jJLRZ/rKl5fMBpRI3KqtPcPP+kPMsupVJ0j7qkna0qJNo/PmtIIGoIOwwU5KXGe0NIyyq2jhO+odjVeJFkCbL13XWnbBLDiVtoox2bUHyjtb9odJRVZMpSDV7ekLv3VPQqljx+o6oIAU75m485oYOg+nWJAkLl6X3IMmPQdhb0K2oyZvn72tPDuN+UFVjyxcZnb3F0X0CWAYpn0HIF/3afeforC8Hi8JaooxKupy7uumQ20WQiLaziYL+f3B5YvaMX01OapqMffHMETPNFCAaB9xjzZlNzNXiT7sE0bZcJ2XvfdFG9X06Kqqp3cf3exkkpWx5zJPb93VzpyBbrmjVi8GTZ7SKoqhkceJlkGJsjIh1fLv+Q0eR2/hx3n1d1eNxgbx3fZ4Mz2LLSkezdPVrv7sB3nRiVdNu/qDKlzuxfg3M2WJDb2Ow6QdB57tbTkjSbDapshamCRtb6fxx3zbd9Jw4Kja8ti50/1vO56K0GTYsjxbPk/lCL/6i0JZ5q8iWhxnXUTtrgzyO09/FeH8fL/fKL9/rD94Rglx5XMQ+QA4OI4sx1RhZEj+w4nutUd5HiDt8SCI7Cb971eQmcTWOJPaJz/fWAV3a1VPeNw4YngIDayqK/8kz1qLnXeHj67LXLXX6RY0czNmylcgxbO0t/3P747Uue95sOm15TU0QFmbHynhib6I3ru4u64t/1SQ4m5ybJpASYyqNzimML/jW8p8r884qY/dfxTjM10sM0//7cXrDF2J059VBvxvjvHa/dT3UN162LJjzJSYwtM91ehTF1rXPNp1R2mdNUyGJAjm0k69GjuHDLlNTgu2pkUPzrooEcRXJoZkaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbPIHLQToXnkxPU4AAAAASUVORK5CYII="

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(34),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(43),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(40),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(42),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(41),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(36),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(35),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(38),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("About"), _c('div', {
    staticClass: "sub"
  }, [_vm._v("becolomochi について")])]), _c('h2', [_vm._v("べこ "), _c('small', [_vm._v("beco")])]), _c('p', {
    staticClass: "about_paragraph"
  }, [_vm._v("Designer / Frontend developer / Illustrator")])]), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section_headline"
  }, [_vm._v("できること")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("HTML5/CSS3/JavaScript")]), _c('li', [_vm._v("プログラミングの基礎")]), _c('li', [_vm._v("ターミナル操作")]), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/becolomochi/status/1021660801982029824",
      "target": "_blank"
    }
  }, [_vm._v("キャラクター制作")])]), _c('li', [_vm._v("Adobe Illustrator を使ったイラストやロゴの作成")]), _c('li', [_vm._v("紙面レイアウト")])])]), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section_headline"
  }, [_vm._v("仕事観")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("「あたたかくて やさしい、しなやかなコミュニケーションを」をモットーにし、フリーランスで仕事をしています。")]), _c('li', [_vm._v("作業は朝（4:00〜7:00ごろ）昼（14:00〜16:00ごろ）しています。")]), _c('li', [_vm._v("Slackやメールは日中も随時対応可能です。")]), _c('li', [_vm._v("過去に会社員をしながら大学の制作課題をこなしていたこともあり、スケジュールにあわせた作業進行が得意です。")]), _c('li', [_vm._v("課題に対してどう改善するかを考えて行動することができます。")]), _c('li', [_vm._v("情報収集を毎日欠かさず行っています。")]), _c('li', [_vm._v("Webサービスが好きで、特にSlackのテキスト／Emojiコミュニケーションが好きです。")]), _c('li', [_vm._v("本をおすすめされればわりとすぐ買ってしまうほうです。")]), _c('li', [_vm._v("少人数のチームで実力を出しやすいです。")])])]), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section_headline"
  }, [_vm._v("経歴")]), _c('h3', [_vm._v("2019年")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("iOSアプリのLP制作"), _c('ul', [_c('li', [_vm._v("HTML/Sass(SCSS)")]), _c('li', [_vm._v("GitHub")]), _c('li', [_vm._v("Adobe Illustrator/Figma")])])]), _c('li', [_vm._v("WebサービスのUI改善"), _c('ul', [_c('li', [_vm._v("PHP/HTML/Sass(SCSS)")]), _c('li', [_vm._v("GitHub")]), _c('li', [_vm._v("Adobe Illustrator/Figma")])])]), _c('li', [_vm._v("キャラクター制作"), _c('ul', [_c('li', [_vm._v("Adobe Illustrator")])])])]), _c('h3', [_vm._v("2018年")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("2018年4月〜 フリーランス（屋号：べころもち工房）")]), _c('li', [_c('a', {
    attrs: {
      "href": "https://creive.me/",
      "target": "_blank"
    }
  }, [_vm._v("creive【クリーブ】")]), _vm._v("さんにて記事公開")]), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/becolomochi/status/1021660801982029824",
      "target": "_blank"
    }
  }, [_vm._v("キャラクター制作")])]), _c('li', [_vm._v("アイコン制作")]), _c('li', [_vm._v("レスポンシブサイトコーディング")]), _c('li', [_c('a', {
    attrs: {
      "href": "http://amzn.asia/d/i9PEPqs",
      "target": "_blank"
    }
  }, [_vm._v("ゼロからわかる Ruby 超入門（技術評論社）イラストを担当")])])]), _c('h3', [_vm._v("〜2017年")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("群馬高専卒業")]), _c('li', [_vm._v("印刷会社にDTPオペレータとして勤務（2009〜2015）"), _c('ul', [_c('li', [_vm._v("折込チラシ・名刺・封筒・DMなど各種印刷物のデザイン")]), _c('li', [_vm._v("印刷用完全データの作成")]), _c('li', [_vm._v("WordPressのカスタマイズ・コーディング")])])]), _c('li', [_vm._v("Web システム開発会社へ（2015〜2017）"), _c('ul', [_c('li', [_vm._v("システムのUI改修")]), _c('li', [_vm._v("Webデザイン・コーディング")]), _c('li', [_vm._v("ロゴデザイン")])])]), _c('li', [_vm._v("京都造形芸術大学 通信教育部 情報デザインコース卒業（2011〜2016）")])])]), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section_headline"
  }, [_vm._v("好きなもの")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_vm._v("ダム")]), _c('li', [_vm._v("生き物（特に犬、猫、ジンベエザメ、アロワナ）")]), _c('li', [_vm._v("自然")]), _c('li', [_vm._v("ゆるキャラ")]), _c('li', [_vm._v("音楽（ジャズ・テクノ・ポップス）")])])]), _c('section', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section_headline"
  }, [_vm._v("関連リンク")]), _c('ul', {
    staticClass: "about_list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://booth.pm/ja/items/667217"
    }
  }, [_vm._v("BOOTH Vue.jsでポートフォリオサイト制作記")]), _c('br'), _vm._v("このポートフォリオサイトの作り方について書いた技術系同人誌です")]), _c('li', [_c('a', {
    attrs: {
      "href": "https://becolomochi.tumblr.com"
    }
  }, [_vm._v("Tumblr")]), _c('br'), _vm._v("イラストやグッズの紹介など")]), _c('li', [_c('a', {
    attrs: {
      "href": "https://becolomochi.hatenablog.com"
    }
  }, [_vm._v("ブログ")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://scrapbox.io/becolomochi"
    }
  }, [_vm._v("Scrapbox")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/becolomochi"
    }
  }, [_vm._v("GitHub")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/becolomochi"
    }
  }, [_vm._v("Twitter")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/becolomochi"
    }
  }, [_vm._v("Instagram")])]), _c('li', [_c('a', {
    attrs: {
      "href": "http://booklog.jp/users/becolomochi"
    }
  }, [_vm._v("Booklog")])]), _c('li', [_c('a', {
    attrs: {
      "href": "http://qiita.com/becolomochi"
    }
  }, [_vm._v("Qiita")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://suzuri.jp/becolomochi"
    }
  }, [_vm._v("グッズ販売")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://store.line.me/stickershop/product/1018430"
    }
  }, [_vm._v("LINEスタンプ")])])])])])
}]}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "footer-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("Works")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page is-wide"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "data": _vm.myData
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("Works")])], 1)])]), _c('article', {
    staticClass: "article"
  }, [_c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v(_vm._s(_vm.filteredData.title))]), _vm._l((_vm.filteredData.picture), function(p) {
    return (p.id === '1') ? _c('div', [_c('img', {
      attrs: {
        "src": p.path,
        "alt": ""
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "works_detail-detail"
  }, [_c('p', {}, [_vm._v(_vm._s(_vm.filteredData.text))]), _c('p', {}, [_vm._v("制作年：" + _vm._s(_vm.filteredData.year))]), _c('p', {}, [_vm._v(_vm._s(_vm.filteredData.role))]), _c('p', {}, [_c('a', {
    attrs: {
      "href": _vm.filteredData.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.filteredData.urlTitle))])])]), _vm._l((_vm.filteredData.picture), function(p) {
    return (p.id !== '1') ? _c('div', [_c('img', {
      attrs: {
        "src": p.path,
        "alt": ""
      }
    })]) : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "nav_list"
  }, [_c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("Works")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header_inner"
  }, [_c('h1', {
    staticClass: "header_title"
  }, [_c('router-link', {
    staticClass: "header_title-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("becolomochi's portfolio")])], 1), _c('hnav')], 1)]), _c('main', {
    staticClass: "main"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "data": _vm.myData
    }
  })], 1)], 1), _c('footer', {
    staticClass: "footer"
  }, [_c('fnav'), _c('div', {
    staticClass: "footer_copyright"
  }, [_vm._v("© 2017-2019 beco")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page is-wide"
  }, [_c('main', [_c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("ページが見つかりません")])])])
}]}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works_top"
  }, [_vm._m(0), _c('ul', {
    staticClass: "works_list"
  }, _vm._l((_vm.data), function(d) {
    return _c('li', {
      staticClass: "works_item"
    }, [_c('router-link', {
      staticClass: "common_link-box",
      attrs: {
        "to": '/works/' + d.slug
      }
    }, [_vm._l((d.picture), function(p) {
      return (p.id === '1') ? _c('div', {
        staticClass: "works_thumb"
      }, [_c('img', {
        attrs: {
          "src": p.path,
          "alt": "イメージ"
        }
      })]) : _vm._e()
    }), _c('h2', {
      staticClass: "works_list-title"
    }, [_vm._v(_vm._s(d.title))])], 2), _c('div', {
      staticClass: "works_list-detail"
    }, [_c('p', {
      staticClass: "works_description"
    }, [_vm._v(_vm._s(d.text))]), _c('p', {
      staticClass: "works_year"
    }, [_vm._v("制作年：" + _vm._s(d.year))])])], 1)
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("Works"), _c('div', {
    staticClass: "sub"
  }, [_vm._v("作品紹介")])])
}]}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_vm._m(0), _c('section', {
    staticClass: "top_works"
  }, [_c('div', {
    staticClass: "top_works-inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Works")]), _c('div', {
    staticClass: "works"
  }, _vm._l((_vm.data), function(d) {
    return _c('div', {
      staticClass: "works_box"
    }, [_c('router-link', {
      staticClass: "common_link-box",
      attrs: {
        "to": '/works/' + d.slug
      }
    }, [_vm._l((d.picture), function(p) {
      return (p.id === '1') ? _c('div', {
        staticClass: "common_thumb effect_img-filter"
      }, [_c('img', {
        attrs: {
          "src": p.path,
          "width": "",
          "height": "",
          "alt": ""
        }
      })]) : _vm._e()
    }), _c('div', {
      staticClass: "works_name"
    }, [_vm._v(_vm._s(d.title))])], 2)], 1)
  }))]), _c('div', {
    staticClass: "common_more"
  }, [_c('router-link', {
    staticClass: "common_more-link",
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("もっと見る")])], 1)]), _c('section', {
    staticClass: "top_about"
  }, [_c('div', {
    staticClass: "section_inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("About")]), _c('div', {
    staticClass: "top_about-inner"
  }, [_c('div', {
    staticClass: "about_text"
  }, [_vm._m(1), _c('div', {
    staticClass: "about_role"
  }, [_vm._v("Designer / Frontend developer / Illustrator")]), _vm._m(2), _c('div', {
    staticClass: "about_other"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("そのほか")])], 1)]), _vm._m(3)])])]), _c('section', {
    staticClass: "top_contact"
  }, [_c('div', {
    staticClass: "section_inner"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Contact")]), _c('div', {
    staticClass: "common_text top_contact-inner"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("お問い合わせフォーム")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_catch"
  }, [_c('div', {
    staticClass: "top_catch-inner"
  }, [_c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "src-set": "../assets/img/txt_top_catch1.png, ../assets/img/txt_top_catch1@2x.png 2x, ../assets/img/txt_top_catch1@3x.png 3x",
      "alt": "あたたかくて"
    }
  })]), _c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "src-set": "../assets/img/txt_top_catch2.png, ../assets/img/txt_top_catch2@2x.png 2x, ../assets/img/txt_top_catch2@3x.png 3x",
      "alt": "やさしい"
    }
  })]), _c('div', {
    staticClass: "character"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(24),
      "src-set": "../assets/img/txt_top_catch3.png, ../assets/img/txt_top_catch3@2x.png 2x, ../assets/img/txt_top_catch3@3x.png 3x",
      "alt": "しなやかなコミュニケーションを"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "about_name"
  }, [_vm._v("べこ"), _c('small', {
    staticClass: "about_small"
  }, [_vm._v("beco")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_sns"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/becolomochi"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v("Twitter")]), _c('a', {
    attrs: {
      "href": "https://github.com/becolomochi"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v("GitHub")]), _c('a', {
    attrs: {
      "href": "https://becolomochi.tumblr.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v("Tumblr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_thumb"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(20),
      "alt": "icon1"
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": "icon2"
    }
  })])
}]}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_vm._m(0), _c('form', [_c('input', {
    attrs: {
      "name": "SPREADSHEET_ID",
      "type": "hidden",
      "value": "1RTlomP3hXQZhHw3arZfng3dJeGJAnz3EcreOeYM1npA"
    }
  }), _c('input', {
    attrs: {
      "name": "SHEET_NAME",
      "type": "hidden",
      "value": "フォームデータ"
    }
  }), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "form text-center"
  }, [_c('button', {
    staticClass: "form_submit",
    attrs: {
      "type": "button",
      "id": "submit"
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Submit")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("Contact "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("お問い合わせ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("メールアドレス")]), _c('input', {
    staticClass: "wide",
    attrs: {
      "type": "email",
      "name": "your-email",
      "placeholder": "your@email.com"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("お名前")]), _c('input', {
    staticClass: "wide",
    attrs: {
      "type": "text",
      "name": "your-name",
      "placeholder": "Your Name"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("メッセージ"), _c('span', {
    staticClass: "label-required"
  }, [_vm._v("必須")])]), _c('textarea', {
    attrs: {
      "name": "your-message",
      "placeholder": "Message",
      "rows": "8",
      "required": "required",
      "id": "message"
    }
  })])
}]}

/***/ })
],[17]);


// WEBPACK FOOTER //
// static/js/app.f02ef5a056154415099f.js